import { Company, CompanyDetail } from "types";

export const formatCompany = (company: Company | CompanyDetail) =>
  `${company.nom_entreprise} (${company.siege.code_postal}) - ${company.siege.siret_formate}`;
